import type { Action } from "../actions/types";

export interface PersonEffectiveDate {
  personGuid: string;
  name: string;
  // Empty when no date is stored; every service then uses the enrolment date.
  effectiveDate: string;
  enrolledAt: string;
  editableUntil: string;
  editable: boolean;
  notEditableReason?: string;
  previousEffectiveDate?: string;
}

export interface PersonAccountState {
  effectiveDate: PersonEffectiveDate | null;
  effectiveDateLoading: boolean;
  effectiveDateSaving: boolean;
  effectiveDateError: string;
  effectiveDateSaved: boolean;

  passwordResetPersonGuid: string;
  passwordResetSending: boolean;
  passwordResetSentTo: string;
  passwordResetError: string;
}

const initialState: PersonAccountState = {
  effectiveDate: null,
  effectiveDateLoading: false,
  effectiveDateSaving: false,
  effectiveDateError: "",
  effectiveDateSaved: false,

  passwordResetPersonGuid: "",
  passwordResetSending: false,
  passwordResetSentTo: "",
  passwordResetError: "",
};

const personAccountReducer = (
  state: PersonAccountState = initialState,
  action: Action
): PersonAccountState => {
  switch (action.type) {
    case "FETCH_PERSON_EFFECTIVE_DATE":
      return {
        ...state,
        effectiveDate: null,
        effectiveDateLoading: true,
        effectiveDateError: "",
        effectiveDateSaved: false,
      };
    case "UPDATE_PERSON_EFFECTIVE_DATE":
      return {
        ...state,
        effectiveDateSaving: true,
        effectiveDateError: "",
        effectiveDateSaved: false,
      };
    case "SET_PERSON_EFFECTIVE_DATE":
      return { ...state, ...action.data };
    case "RESET_PERSON_PASSWORD":
      return {
        ...state,
        passwordResetPersonGuid: action.data,
        passwordResetSending: true,
        passwordResetSentTo: "",
        passwordResetError: "",
      };
    case "SET_PERSON_PASSWORD_RESET":
      return { ...state, ...action.data };
    case "CLEAR_PERSON_ACCOUNT":
      return initialState;
    default:
      return state;
  }
};

export default personAccountReducer;
